module.exports = __webpack_public_path__ + "static/live-tracking-sq-small-ccb51ae63d62c6f645564652f471642d.jpg";